import { Component } from '@angular/core';

@Component({
  templateUrl: './ledger-sidebar.component.html',
})
export class LedgerSidebarComponent {}



// WEBPACK FOOTER //
// /srv/src/app/ledger-sidebar.component.ts